import { useEffect } from 'react';

export const useDisableScroll = (disableScroll: boolean = true) => {
  useEffect(() => {
    if (!disableScroll) return;

    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [disableScroll]);
};
